export enum ApiErrorCodes {
    INVALID_CLIENT_MESSAGE = 'INVALID_CLIENT_MESSAGE',
    INVALID_CREDENTIALS_MESSAGE = 'INVALID_CREDENTIALS_MESSAGE'
}